<template>
  <b-card>
    <title-name />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/Feature_groups/elements/Title.vue'

export default {
  name: 'FeatureGroupsForm',
  components: {
    BCard,
    TitleName,
  },
}
</script>
